import { AssetDetailsSummary } from '@Types/asset.types';
import { createAction } from '@reduxjs/toolkit';

export const getAssetSummaryResolved = createAction<{
	id: string;
	asset: AssetDetailsSummary;
}>('assets/getAssetSummary/resolved');
